import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const trackersApi = baseApi.injectEndpoints({
  tagTypes: ["PatientLetters"],
  endpoints: (builder) => ({
    getTrackerList: builder.query({
      query: () => {
        return {
          url: `/trackers/index.json`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    saveLogTracker: builder.mutation({
      query: (body) => {
        return {
          url: `/trackers/log_tracker.json`,
          method: "POST",
          body: body,
        };
      },
    }),
    getTrackerHistory: builder.query({
      query: (params) => {
        return {
          url: `/trackers/tracker_values.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetTrackerListQuery,
  useSaveLogTrackerMutation,
  useGetTrackerHistoryQuery,
} = trackersApi;
